<div class="rb-ann" *ngIf="visible" role="status">
  <span class="rb-ann-accent" aria-hidden="true"></span>

  <div class="rb-ann-main">
    <div class="rb-ann-head">
      <span class="rb-ann-badge" *ngIf="badge">{{ badge }}</span>
      <h4 class="rb-ann-title">{{ title }}</h4>
    </div>

    <p class="rb-ann-body" *ngIf="body">{{ body }}</p>

    <a
      class="rb-ann-cta"
      *ngIf="route && ctaLabel"
      [routerLink]="route"
      (click)="dismiss()">
      {{ ctaLabel }} <span aria-hidden="true">›</span>
    </a>
  </div>

  <button
    type="button"
    class="rb-ann-close"
    (click)="dismiss()"
    [attr.aria-label]="'GENERAL.CLOSE' | translate">
    <i class="pi pi-times"></i>
  </button>
</div>
